import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const paths = {
    home: "m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z",
    dashboard: "M3 3h7v7H3z M14 3h7v11h-7z M3 14h7v7H3z M14 18h7v3h-7z",
    building: "M4 21V7l8-4v18 M12 9h8v12 M2 21h20 M7 9v1 M7 13v1 M7 17v1 M16 12h1 M16 16h1",
    users: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M16 4a4 4 0 0 1 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    cart: "M2 3h3l3 12h11l3-9H6 M10 20h.01 M18 20h.01",
    box: "m3 7 9-4 9 4v10l-9 4-9-4Z M3 7l9 5 9-5 M12 12v9 M7.5 5l9 5",
    briefcase: "M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2 M3 6h18v14H3z M3 11l9 3 9-3 M12 12v4",
    document: "M14 2H5v20h14V7Z M14 2v6h5 M8 12h8 M8 16h8",
    settings: "m9 3-1 3-3 1-2 5 2 5 3 1 1 3h6l1-3 3-1 2-5-2-5-3-1-1-3Z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
    trend: "M3 3v18h18 M6 15l5-5 4 3 6-8 M16 5h5v5",
    alert: "m12 3 10 18H2Z M12 9v5 M12 17h.01",
    check: "m5 12 4 4L19 6",
    checkCircle: "M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3",
    arrow: "M4 12h16 m-6-6 6 6-6 6",
    chevron: "m9 5 7 7-7 7",
    more: "M5 12h.01 M12 12h.01 M19 12h.01",
    search: "M20 20l-5-5 M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0",
    bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4",
    logout: "M9 21H3V3h6 M9 12h12 m-5-5 5 5-5 5",
    calendar: "M4 5h16v16H4z M4 10h16 M8 3v4 M16 3v4 M8 14h2 M14 14h2 M8 18h2",
    shield: "m12 3 9 4c0 7-3 11-9 14C6 18 3 14 3 7Z m-4 9 3 3 5-6",
    plus: "M12 5v14 M5 12h14",
    wifi: "M2 8a16 16 0 0 1 20 0 M5 12a11 11 0 0 1 14 0 M8 16a6 6 0 0 1 8 0 M12 20h.01",
    clock: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M12 6v6l4 2",
    eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12 M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
    eyeOff: "m3 3 18 18 M10.5 5.1 12 5c6 0 10 7 10 7a21 21 0 0 1-3 3.7 M6.3 6.3A21 21 0 0 0 2 12s4 7 10 7a12 12 0 0 0 5.7-1.7 M10 10a3 3 0 0 0 4 4",
};
/** A consistent, dependency-free set of outline icons. Labels belong to the containing control. */
export function Icon({ name, size = 20, ...props }) {
    return _jsx("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false", ...props, children: _jsx("path", { d: paths[name] }) });
}
export function BrandMark({ className = "" }) {
    return _jsx("span", { "aria-hidden": "true", className: `inline-grid size-10 shrink-0 place-items-center rounded-xl bg-navy text-white ${className}`, children: _jsxs("svg", { width: "26", height: "26", viewBox: "0 0 28 28", fill: "none", children: [_jsx("path", { d: "M6 5h17v4H10v4h10v4H10v6H6V5Z", fill: "currentColor" }), _jsx("path", { d: "M14 20h9v3h-9z", fill: "#62d596" })] }) });
}
//# sourceMappingURL=Icon.js.map